var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 11",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.392V.62C0 .166.483-.172.962.093c.383.213 8.04 4.509 8.693 4.877a.598.598 0 010 1.058c-.47.27-8.156 4.588-8.713 4.888-.407.22-.942-.023-.942-.524z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTAgMTEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBhdGggZD0iTS0wLjAwMCAxMC4zOTJDLTAuMDAwIDkuODg0IC0wLjAwMCAwLjk3MCAtMC4wMDAgMC42MjBDLTAuMDAwIDAuMTY2IDAuNDgzIC0wLjE3MiAwLjk2MiAwLjA5M0MxLjM0NSAwLjMwNiA5LjAwMiA0LjYwMiA5LjY1NSA0Ljk3MEMxMC4wODQgNS4yMTEgMTAuMDc3IDUuNzg3IDkuNjU1IDYuMDI4QzkuMTg1IDYuMjk4IDEuNDk5IDEwLjYxNiAwLjk0MiAxMC45MTZDMC41MzUgMTEuMTM2IC0wLjAwMCAxMC44OTMgLTAuMDAwIDEwLjM5MloiIC8+Cjwvc3ZnPg==";
export { SvgArrow as ReactComponent };